






































































































































































































































































































































































































































































































































































































































































import { Component, Vue , Watch } from 'vue-property-decorator';
import Jobseeker from './../Jobseeker.vue';
import Myreferrals from './../Myreferrals.vue';
import Referrals from './../Referrals.vue';
import SupportingDocuments from './../SupportingDocuments.vue';
import { vxm } from '@/store.vuex';
import { Job } from '@/models/jobs/job';
import { Referral } from '../../models/referrals/referral';
import { ApplyRequestWrapper } from '../../models/jobs/jobapply';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import router from '../../router';
import JobMainInfo from '@/components/Commons/JobMainInfo.vue';
import { CommonUserInfo } from '../../models/referrals/commonuserinfo';
import ReferralProgramusd from './../SvgIcons/ReferralProgramusd.vue';
import ReferralProgramgbp from './../SvgIcons/ReferralProgramgbp.vue';
import MessageModal from './../Commons/MessageModal.vue';
import { JobTagConfig } from '../../models/jobs/jobtagconfig';
import { CandidatePortalClientCommonInfo } from '../../models/utility/lookup';
import JobPostingJsonLD from './../JsonLD/JobPostingJsonLD.vue';
import { Company } from '../../models/company/companyprofile';
import SimilarJobs from '@/components/Commons/SimilarJobs.vue';
import SimilarJobsAlert from '@/components/Commons/SimilarJobsAlert.vue';
import { getJobTypeText } from './../MyJobs/MyJobsUtils';
import FindJobsLink from './../Registration/FindJobsLink.vue';
import NewJobApplyFlow from './NewJobApplyFlow.vue';
import { User } from '@/models/userdata/userdto';
import { JobApplication } from '@/models/jobs/jobapplication';
import { JobActionCodeConstants } from '@/components/QuickApply/JobActionCodeConstants';
import { QuestionnaireResponse,QuestionnaireDetailRequest } from '@/models/jobs/questionnaireresponse';
import { ResumePayload } from '@/models/jobs/resumepayload';
import { UserParams } from '@/models/userdata/userparams';
declare var window: any;
Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 3000,
});

@Component({
  name: 'QuickApplyJobdetails',
  components: {
    Jobseeker,
    Myreferrals,
    Referrals,
    SupportingDocuments,
    NewJobApplyFlow,
    ReferralProgramusd,
    ReferralProgramgbp,
    JobMainInfo,
    JobPostingJsonLD,
    SimilarJobs,
    SimilarJobsAlert,
    FindJobsLink
  },
})
export default class QuickApplyJobdetails extends Vue {
  private jobDetailsError: string = '';
  private showDetail: boolean = false;
  private job: Job[] = [];
  private distance: number = 0;
  private isExpandedJob: boolean = false;
  private isJobApplied: boolean = false;
  private userId : string = '';
  private disableUser : boolean = false;
  public  isBranched : boolean = false;
  public isGDPREnabled: boolean = true;
  public hasBranchedQuestionere : boolean =false;
  public questionTemplateId: number = 0;
  private hideApplyButton: boolean = false;
  private jobDetail: any[] = [];
  private showApplyButton: boolean = false;
  private gdprObj = { marketingEmailFlag: false, tosEmailFlag: false };
  private candidatePhone: string = '';
  private jobPostingId: number = 0;
  private validateUser : boolean = false;
  $wlToastr: any;
  $moment: any;
  private bookmarks: any[] = [];
  public JOBPOSTING_ASSIGNMENT_STATUS_SCREENING = '20';
  public JOBPOSTING_ASSIGNMENT_STATUS_INTERVIEW = '30';
  public JOBPOSTING_ASSIGNMENT_STATUS_REVIEW = '35';
  public SCREENING_STATUS_ALERT = 'Your application is being screened';
  public REVIEW_STATUS_ALERT = 'Your application is being reviewed';
  public INTERVIEW_STATUS_ALERT = 'You’ve been selected for an interview';
  public INTERVIEW_SUB_STATUS_COMPLETED = 'Completed';
  public INTERVIEW_SUB_STATUS_CANCELLED = 'Cancelled';
  private job_;
  public localjobs: Job[] = [];
  public message = 'Your application is being reviewed';
  private externalUrl = '';
  public externalJobId = '';
  private userParams: UserParams = new UserParams();
  private skills: any[] = [];
  private categories: any[] = [];
  private industries: any[] = [];
  private facilities: any[] = [];

  private wlUser: User = new User();
  //$toastr: any;
  private socialRegistrationType: string = '';
  private noExample: boolean = true;

  private resumeUploadRequired: boolean = false;
  private jobResumeUploadRequired: string = '';
  private degreeUploadRequired: boolean = false;
  private questionnaireRequired: boolean = false;
  private enableResumeUploadBtn: boolean = false;
  private isResumeActionComplete: boolean = false;
  private isDegreeActionComplete: boolean = false;
  private questionnaireActionCompleted: boolean = false;
  public userDetails : User = new User;
  public errors = {

    email: '',
    password: '',
    confirmPassword: '',
    firstName: '',
    lastName: '',
    phone: '',
  };
  private hasNextQuestion : boolean = false;
  private branchQuestionVal : boolean = true;
  private CompanyInfo: Company = new Company();

  private showDoorwayPages: boolean = false;

  private MaxDescriptionLength: number = 55;
  private ShowFullDescription: boolean = false;
  private jobApplicationSteps: any[] = [];
  private questionnaireResponse = new QuestionnaireResponse();
  private resumePayload: ResumePayload = new ResumePayload();
  private agreeTerms: boolean = false;
  private agreeReceiveEmail: boolean = this.marketingNotificationText.trim() ? false : true;

  updateFlag() {
    this.wlUser.userAgreement = this.agreeTerms;
  }

  get enableAnonymousSavedJobs() {
    return vxm.configs.getGlobalConfigValue('ENABLE_ANONYMOUS_SAVED_JOBS');
  }

  get JobAdminComment(): string {
    return vxm.jobs.UserJob.adminComment || vxm.jobs.JobAdminMessage;
  }

  get isDynamicHeaderInjectionEnabled() {
    const showHtml = vxm.configs.getGlobalConfigValue('HEADER_HTML') ? true : false
    if(vxm.configs.IsConfigJSONEnabled){
      return showHtml;
    } else {
      return vxm.configs.getGlobalConfigValue('ENABLE_DYNAMIC_HEADER_INJECTION') && showHtml;
    }
  }

  get showWidgetsPanel(): boolean {
    return (
      this.showDoorwayPages || this.showSimilarJobs || this.showSimilarJobsAlert
    );
  }

  get showSimilarJobs(): boolean {
    return vxm.configs.getGlobalConfigBooelanValue('WL_SIMILAR_JOB_FEATURE_ENABLED')
  }
  get ShowGuidedSignup(): boolean {
    return vxm.configs.GuidedSignupEnabled;
  }

  get showSimilarJobsAlert(): boolean {
    return (
      vxm.configs.getGlobalConfigValue('ENABLE_SIMILAR_JOBS_ALERT') &&
      !vxm.configs.getGlobalConfigValue('ENABLE_JOBALERT_V2')
    );
  }

  getDisciplineList(job) {
    if (job.jobPostingMetaData && Array.isArray(job.jobPostingMetaData)) {
      const disciplineField = job.jobPostingMetaData.find(
        (field) => field.label === 'Discipline',
      );
      if (
        disciplineField &&
        job.jobPostingCustomData &&
        job.jobPostingCustomData[disciplineField.name]
      ) {
        const disciplineIds = job.jobPostingCustomData[
          disciplineField.name
        ].split(',');
        if (Array.isArray(disciplineIds)) {
          return disciplineIds
            .map((id) => {
              return disciplineField.displayList[
                disciplineField.valueList.indexOf(id)
              ];
            })
            .filter((fieldValue) => fieldValue && fieldValue != null);
        }
        return [];
      }
      return [];
    }
    return [];
  }

  showHeader() {
    return (
      this.job_ &&
      this.job_.jobPostingAssignmentStatus &&
      (this.job_.jobPostingAssignmentStatus ===
        this.JOBPOSTING_ASSIGNMENT_STATUS_SCREENING ||
        this.job_.jobPostingAssignmentStatus ===
          this.JOBPOSTING_ASSIGNMENT_STATUS_INTERVIEW ||
        this.job_.jobPostingAssignmentStatus ===
          this.JOBPOSTING_ASSIGNMENT_STATUS_REVIEW)
    );
  }

  showInterviewSlot() {
    return (
      this.job_.subStatusDescription != this.INTERVIEW_SUB_STATUS_COMPLETED &&
      this.job_.subStatusDescription != this.INTERVIEW_SUB_STATUS_CANCELLED
    );
  }

  goToUpload(jobPosting: any, externalJobUrl: string) {
    const jid = jobPosting.jobPostingId;
    //this.applyJob(jid);
  }

  applyJob(jid: string) {
    const jobApply = new JobApplication();
    vxm.jobs.setJobID(parseInt(jid, 10));
    jobApply.jobPostingId = parseInt(jid, 10);
    jobApply.companyCode = this.$store.state.jobs.companyCode;
    jobApply.resumeCode = this.jobResumeUploadRequired;
    if (!this.isJobApplied) {
      // jobApply.applyRequest.referralCode = this.$route.params.referralCode;
    }
    const respPromise: any = vxm.jobs.anonApplyWithResumeGuid(jobApply);
    this.$modal.show('survey-spinner');
    Promise.all([respPromise]).then((resp) => {
      this.$modal.hide('survey-spinner');
      this.processJobApplicationResponse(resp, jid);
    });
  }
  get termsOfServiceURL() {
    return vxm.configs.getCompanyPreference(
      'CANDIDATE_PORTAL_TERMS_OF_SERVICE_END_POINT_URL',
      'termsLink',
    );
  }
  get privacyPolicyURL() {
    return vxm.configs.getCompanyPreference(
      'CANDIDATE_PORTAL_PRIVACY_POLICY_END_POINT_URL',
      'privacyLink',
    );
  }
  get enableApplyBtn(): boolean {
    if (this.resumeUploadRequired && !this.isResumeActionComplete) {
      return false;
    }
    if (this.questionnaireRequired && !this.questionnaireActionCompleted) {
      return false;
    }
    if(this.hasNextQuestion  && this.hasBranchedQuestionere){
      return false;
    }
    if(!this.branchQuestionVal && this.hasBranchedQuestionere){
      return false;
    }
    if (
      vxm.configs.getGlobalConfigValue('IS_GDPR_ENABLED') &&
      (!this.agreeTerms || !this.agreeReceiveEmail)
    ) {
      return false;
    }
    return true;
  }

  showPopup(externalJobUrl: string, message: string, jid: string) {
    this.externalUrl = externalJobUrl;
    this.externalJobId = jid;
    var msgModal =
      externalJobUrl == 'Login'
        ? this.openExtUrlWindowWithoutLogin
        : this.openExtUrlWindow;
    this.$modal.show(
      MessageModal,
      {
        body: message,
        onOk: msgModal,
      },
      {
        height: 'auto',
        clickToClose: false,
      },
    );
  }
  openExtUrlWindow() {
    this.applyJob(this.externalJobId);
    window.open(this.externalUrl, '_blank');
  }

  openExtUrlWindowWithoutLogin() {
    this.$router.push({ name: 'Login' });
  }

  processJobApplicationResponse(resp, jid: string) {
    let apply = resp[0]['data'];
    if (apply.nextPage === 'otpauthentication') {
      if (vxm.utility.useLoginSignupV2) {
        this.setNavigation('JobDetails:' + jid);
      }
      this.$router.push({ name: 'Verification' });
    }
    // error code 1001 resume
    if (
      apply.errorCode === '1001' ||
      apply.nextPage === 'questionnaire' ||
      apply.nextPage === 'supportinginfo'
    ) {
      this.$cookies.remove('SubmitJobApplicationId');
      this.showApplyButton = false;
      localStorage.nextpage =
        apply.errorCode === '1001' ? 'resume' : apply.nextPage;
      this.isJobApplied = true;
      return;
    }

    if (apply.errorCode === '1002') {
      this.showMessage(apply, jid);
      return;
    }

    if (apply.nextPage === 'success') {
      this.showMessage(apply, jid);
      return;
    }
    this.showMessage(apply, jid);
  }

  showMessage(value, jid: string) {
    if (value) {
      if (!value.success) {
        if (value.errorCode === '1002') {
          const errorMessageText = value.errorMessage;
          this.$wlToastr('error', errorMessageText, this.$t('MyJobListing_JobApplication'));
        }
      } else {
        this.$cookies.remove('SubmitJobApplicationId');
        if (value.nextPage === 'success') {
          vxm.users.Rudderstack.trackEvent("Job Apply Submitted", { jobPostingId: jid});
          const successMessage = this.$t('jobs.successfully.applied');
          this.$wlToastr('success', successMessage, this.$t('MyJobListing_JobApplication'));
          vxm.jobs.setAppliedJob(jid);
          if (
            vxm.configs.getGlobalConfigValue('GSU_AFTER_JOB_APPLY') &&
            vxm.configs.GuidedSignupEnabled &&
            !vxm.jobs.GuidedSignUpOccured
          ) {
            this.$router.push({ name: 'GuidedSignup' });
          } else {
            this.$router.push({
              name: 'JobApplicationSuccess',
              params: { jid },
            });
          }
        }
      }
    }
  }

  setNavigation(path: string) {
    this.$cookies.set('NavigateTo_ID', path, 600);
    let apply = this.$route.query.apply;
    if (vxm.utility.useLoginSignupV2) {
      apply = undefined === apply ? 'true' : apply;
    }
    this.$cookies.set('apply', apply, 600);
  }

  bookmarkClass(job) {
    if (
      job.bookmarkStatus &&
      job.bookmarkStatus === 'A' &&
      job.hasAppliedJob != true
    ) {
      return 'fa fa-bookmark add-color';
    } else {
      return 'fa fa-bookmark-o remove-color';
    }
  }

  parseUrl(videoURL: string): string {
    const nArr = videoURL.split('=');
    return nArr[1];
  }

  processJobApplicationStep(jobApplicationStepsData: any) {
    console.log(jobApplicationStepsData);
    const stepName = jobApplicationStepsData.stepName;
    const completed = jobApplicationStepsData.completed;

    if (JobActionCodeConstants.RESUME === stepName) {
      this.isResumeActionComplete = completed;
      this.resumePayload = jobApplicationStepsData.data;
    } else if (JobActionCodeConstants.QUESTIONNARE === stepName) {
      this.questionnaireActionCompleted = completed;
      this.questionnaireResponse = jobApplicationStepsData.data;
      console.log("step completed Or not ",completed,"jobApplicationStepsData.data",jobApplicationStepsData.data);
    }
  }
  get userSourceType(){
  return vxm.configs.getGlobalConfigValue('USER_SOURCE_TYPE');
}
  disableUserDetails(val){
    console.log("disableuserdetails",val, "original val",this.disableUser);
    if(val >0 &&(val!= null || val!=0) ){
      this.disableUser = true;
      this.wlUser.userId = val;
    }
    return this.disableUser ;
  }
  
  validateOAuthRegistrationData(user: User): boolean {
    let isValid: boolean = true;
    this.errors = {
      email: '',
      password: '',
      confirmPassword: '',
      firstName: '',
      lastName: '',
      phone: '',
    };
    const emailformat = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (!user.firstName) {
      this.errors.firstName = 'signup.firstname.required';
    }
    if (!user.lastName) {
      this.errors.lastName = 'signup.lastname.required';
    }
    if (!user.email.match(emailformat)) {
      this.errors.email = 'signup.enter.valid.email';
    }
    if (!user.email) {
      this.errors.email = 'signup.email.required';
    }
    if (!user.phoneNumberValid) {
      this.errors.phone = 'signup.phone.valid';
    }
    if (!user.phone) {
      this.errors.phone = 'signup.phone.required';
    }

    const resumeCode = this.jobResumeUploadRequired;
    if (
      this.resumeUploadRequired &&
      !this.resumePayload.resumefile &&
      JobActionCodeConstants.RESUME_UPLOAD_MANDATORY === resumeCode
    ) {
      this.$wlToastr(
        'error',
        'Resume is mandatory for job application submission!',
        '',
      );
      return false;
    }
    Object.keys(this.errors).forEach((key) => {
      isValid = isValid && !this.errors[key];
    });
    return isValid;
  }
  get companyCode() {
    return vxm.jobs.CompanyInfo.companyId;
  }
  get marketingNotificationText() { 
    return vxm.jobs.BrandingInfo.SIGNUP_ADDITIONAL_CONSENT;
  }
  async submitJobApplication() {
    this.userParams.email = this.wlUser.userName;
    if (this.wlUser.firstName) {
      this.wlUser.firstName = this.wlUser.firstName.trim();
    }
    if (this.wlUser.lastName) {
      this.wlUser.lastName = this.wlUser.lastName.trim();
    }

    if (!this.wlUser.companyCode) {
      this.wlUser.companyCode = vxm.users.getCompanyCode;
    }

    this.wlUser.userName = this.wlUser.email;
    this.userParams.firstName = this.wlUser.firstName;
    this.userParams.lastName = this.wlUser.lastName;
    this.userParams.phone = this.wlUser.phone;
    this.userParams.password = this.wlUser.password;
    if(this.userSourceType && this.userSourceType.length>0){
      this.wlUser.userSourceType= this.userSourceType
    }
    this.wlUser.referralCode =  vxm.referrals.globalRefCode;
    if (this.validateOAuthRegistrationData(this.wlUser)) {
      const formData = new FormData();
      var userAgreement =  this.wlUser.userAgreement.toString();
      formData.append('userAgreement',userAgreement)
      formData.append('user', JSON.stringify(this.wlUser));
      if (this.resumePayload && this.resumePayload.resumefile) {
        formData.append('resumefile', this.resumePayload.resumefile);
      }

      formData.append('sourceChannel','Talent Portal');
      if (!this.jobPostingId) {
        this.$wlToastr('error', 'Job posting is undefined', '');
      }
      formData.append(
        'resume',
        '{"resumename": "", "resumeLink":"' +
          this.resumePayload.resumelink +
          '","jobpostingid":' +
          this.jobPostingId +
          '}',
      );

      if (!this.hasBranchedQuestionere &&
        this.questionnaireResponse &&
        this.questionnaireResponse.questionResponseData &&
        this.questionnaireResponse.questionResponseData.length > 0
      ) {
        formData.append(
          'questionnaireInfo',
          JSON.stringify(this.questionnaireResponse),
        );
      }
      else if(this.hasBranchedQuestionere){
        let questionnaireInfo = {
            userId : this.wlUser.userId,
            jobPostingId : this.$route.params.JobID,
            questionTemplateId : this.questionTemplateId
          }
          formData.append(
          'questionnaireInfo',
          JSON.stringify(questionnaireInfo),
        );
      }
      if(this.hasBranchedQuestionere && this.questionnaireResponse &&
        this.questionnaireResponse.questionResponseData &&
        this.questionnaireResponse.questionResponseData.length > 0){
          let questionnaireDetailRequset : QuestionnaireDetailRequest = new QuestionnaireDetailRequest();
          questionnaireDetailRequset.hasAnsweredAll = true;
          questionnaireDetailRequset.companyCode = this.companyCode;
          questionnaireDetailRequset.questionnaireInfo.jobPostingId = this.$route.params.JobID;
          questionnaireDetailRequset.questionnaireInfo.referralCode= vxm.referrals.globalRefCode
           ? vxm.referrals.globalRefCode: '';
          questionnaireDetailRequset.navigation = "next";
          questionnaireDetailRequset.currentQuestionId = Number(this.questionnaireResponse.questionResponseData[0].questionID);
          questionnaireDetailRequset.questionnaireInfo.questionResponseData = this.questionnaireResponse.questionResponseData;
          questionnaireDetailRequset.questionnaireInfo.userId = this.wlUser.userId;
          questionnaireDetailRequset.questionnaireInfo.questionTemplateId = this.questionTemplateId + '';
          vxm.jobs.getAnonJobApplicationBranchedQuestions(questionnaireDetailRequset);
      }
  
      formData.append('jobPostingId', JSON.stringify(this.jobPostingId));
      if (vxm.utmtracker.utmTrackerId > 0) {
       formData.append('utmTrackerId', JSON.stringify(vxm.utmtracker.utmTrackerId));
      }
      formData.append(
        'companyCode',
        JSON.stringify(vxm.jobs.BrandingInfo.companycode),
      );

      formData.append('resumeUploadRequired', this.jobResumeUploadRequired);
      if(this.hasBranchedQuestionere){
        this.isBranched = true;
      }
      formData.append('isBranched',this.isBranched.toString());
      const jobApplicationResponse = await vxm.jobs.quickAnonJobApply(formData);

      if (
        jobApplicationResponse &&
        jobApplicationResponse.data &&
        jobApplicationResponse.data.success &&
        jobApplicationResponse.data.userId
      ) {
        const jobID = this.jobPostingId.toString();
        const email = this.wlUser.email;
        this.$router.push({
          name: 'AnonJobApplicationSuccess',
          params: { userName: email, jobId: jobID },
        });
        this.$wlToastr(
          'success',
          '',
          this.$t('jobapplication-success-message'),
        );
        vxm.jobs.setAppliedJob(jobID);
      }
      else {
        this.$wlToastr('error', jobApplicationResponse.data.errorMessage, this.$t('ResumeDetails_UploadResume'));
        if (sessionStorage && sessionStorage.getItem("vuex")) { 
          sessionStorage.removeItem("vuex");
        }
        return;
      }
    }
  }
  redirectToSignupPage(email) {
    const userNameValue = this.$route.params.userName;
    router.push({
      name: 'LoginUniversalEntryPoint',
      params: { userName: email, postQuickApplySignupAction: 'true' },
    });
  }

  goToReferral(job: Job) {
    let jid = job.jobPostingId + '';
    vxm.referrals.setJobID(parseInt(jid, 10));
    vxm.referrals.setRefferedJob(job.jobPostingName);
    this.$cookies.remove('referralSuccess');
    this.$cookies.remove('frictionLess');
    const referral = new Referral();
    referral.jobPostingId = parseInt(jid, 10);
    if (vxm.users.isLoggedIn === false) {
      vxm.referrals.setReferral(referral);
      this.$router.push({ name: 'JobShare', params: { JobID: jid } });
    } else {
      referral.userFullName =
        vxm.users.myUserProfile.firstName +
        ' ' +
        vxm.users.myUserProfile.lastName;
      referral.email = vxm.users.myUserProfile.email;
      // referral.referralCode = this.$route.params.referralCode;
      referral.companyCode = vxm.jobs.BrandingInfo.companycode;
      referral.referredJobLocation = job.facility.name;
      console.log(referral);
      vxm.referrals.setReferral(referral);
      vxm.referrals.jobShareReferral(referral);
    }
  }

  getJobTagStyle(jobTagObj) {
    let styleObj = {};
    if (
      jobTagObj &&
      jobTagObj.meta &&
      jobTagObj.meta.style &&
      jobTagObj.meta.style.fontColor
    ) {
      styleObj['color'] = jobTagObj.meta.style.fontColor;
    }
    if (
      jobTagObj &&
      jobTagObj.meta &&
      jobTagObj.meta.style &&
      jobTagObj.meta.style.backgroundColor
    ) {
      styleObj['background'] = jobTagObj.meta.style.backgroundColor;
    }
    if (
      jobTagObj &&
      jobTagObj.meta &&
      jobTagObj.meta.style &&
      jobTagObj.meta.style.backgroundColorOpacity
    ) {
      styleObj['opacity'] = jobTagObj.meta.style.backgroundColorOpacity;
    }
    return styleObj;
  }

  toggleReferralIndex() {
    if (this.isExpandedJob === false) {
      this.isExpandedJob = true;
    } else {
      this.isExpandedJob = false;
    }
  }

  isExpanded(): boolean {
    if (this.isExpandedJob === true) {
      return true;
    } else {
      return false;
    }
  }

  getJobTags(jobTags: string) {
    if (jobTags) {
      let jobTagValues = new Set(jobTags);
      let jobTagConfigs: JobTagConfig[] = vxm.jobs.JobTagConfigs;
      if (jobTagConfigs && jobTagConfigs.length > 0) {
        return jobTagConfigs
          .filter((tagConf) => jobTagValues.has(tagConf.tagName))
          .sort((a, b) => a.sequence - b.sequence);
      }
    }
    return [];
  }

  goBackRoute() {
    this.$router.go(-1);
  }

  getDistance(job: Job) {
    if (job.distance) {
      if (job.distance > 0.1) {
        return job.distance.toFixed(1);
      } else {
        return '< 0.1';
      }
    } else {
      return '0.0';
    }
  }

  getCompanyDistanceUnits(): string {
    if (vxm.jobs.getCompanyDistanceUnit == 'kilometers') {
      return 'km';
    }
    return 'mi';
  }

  get isLoggedIn(): boolean {
    return vxm.users.isLoggedIn;
  }

  JobID() {
    return parseInt(this.$route.params.JobID, 10);
  }

  jobDetails() {
    let p: Promise<any> = vxm.users.isLoggedIn
      ? vxm.jobs.getJobByID(this.JobID() + '')
      : vxm.jobs.getAnonymousJobByID(this.JobID() + '');

    return p.then((resp) => {
      if (resp.jobPostingErrors && resp.jobPostingErrors[0]) {
        this.jobDetailsError = resp.jobPostingErrors[0].jobPostingErrorMessage;
        if(resp.jobPostingErrors[0].jobPostingErrorCode == 1121){
          this.jobDetailsError = this.$t('errorcode.1121').toString();
        }
        if(resp.jobPostingErrors[0].jobPostingErrorCode == 1122){
          this.jobDetailsError = this.$t('errorcode.1122').toString();
        }
        if(resp.jobPostingErrors[0].jobPostingErrorCode == 1127){
          this.jobDetailsError = this.$t('errorcode.1127').toString();
        }
        if(resp.jobPostingErrors[0].jobPostingErrorCode == 1128){
          this.jobDetailsError = this.$t('errorcode.1128').toString();
        }
        if(resp.jobPostingErrors[0].jobPostingErrorCode == 1123){
          this.jobDetailsError = this.$t('errorcode.1123').toString();
        }
        if(resp.jobPostingErrors[0].jobPostingErrorCode == 1129){
          this.jobDetailsError = this.$t('errorcode.1129').toString();
        }
        if(resp.jobPostingErrors[0].jobPostingErrorCode == 1124){
          this.jobDetailsError = this.$t('errorcode.1124').toString();
        }
        return;
      }

      const jInfo: Job[] = [];
      jInfo.push(vxm.jobs.AnonymousJobByID);
      if (resp.publishedJobs && resp.publishedJobs[0]) {
        this.distance = resp.publishedJobs[0].distance;
      }
      jInfo.forEach((job) =>
        job.savedDTTM ? (job.bookmarkStatus = 'A') : (job.bookmarkStatus = 'D'),
      );
      this.jobDetail = jInfo;
    });
  }

  assignErrors(val){
    this.errors = val;
  }

  hasNextQuestionVal(val){
    this.hasNextQuestion = val;
  }

  branchQuestionComplete(val){
  this.branchQuestionVal = val;
  }

  quickJobApplyAllowed(workflowStepActions: any[]): boolean {
    if (!workflowStepActions || workflowStepActions.length == 0) {
      return true;
    }

    const workflowStepActionsData = workflowStepActions.filter(
      (workflowStepAction) =>
        JobActionCodeConstants.RESUME_REQUIRED !==
          workflowStepAction['actionCode'] &&
        JobActionCodeConstants.QUESTIONNAIRE_REQUIRED !==
          workflowStepAction['actionCode'],
    );
    if (workflowStepActionsData && workflowStepActionsData.length === 0) {
      return true;
    }
    return false;
  }

  mounted() {
    if (vxm.users.myUserProfile.email != null) {
      this.wlUser.firstName = vxm.users.myUserProfile.firstName;
      this.wlUser.lastName = vxm.users.myUserProfile.lastName;
      this.wlUser.email = vxm.users.myUserProfile.email;
      this.candidatePhone = vxm.users.myUserProfile.phoneNum;
    }
    this.isGDPREnabled = vxm.configs.getGlobalConfigValue('IS_GDPR_ENABLED');
    if (!this.isGDPREnabled) {
      this.wlUser.userAgreement = true;
    }
    const jobid = this.$route.params.JobID;
    this.jobPostingId = parseInt(jobid, 10);
    const jobSlug = this.$route.params.JobSlug;
    const apply = this.$route.query.apply;
    const refer = this.$route.query.refer;
    const showReferralDetails = this.$route.query.showReferralDetails;
    const submitJobApplicationId = this.$cookies.get('SubmitJobApplicationId');

    if (localStorage.getItem('localjobs')) {
      this.localjobs = JSON.parse(localStorage.getItem('localjobs') || '[]');
      //console.log('local jobs:' + localStorage.localjobs);
    }

    this.showApplyButton = true;

    vxm.jobs.getAnonJobApplicationWorkflowSteps(jobid).then(
      (response) => {
        const jobApplicationStepsObj = vxm.jobs.jobApplicationWorkflowSteps;
        this.hasBranchedQuestionere =  jobApplicationStepsObj.questionareInfo.hasBranchedQuestions;
        this.questionTemplateId = jobApplicationStepsObj.questionareInfo.questionTemplateId;
        console.log("response of anon get workflow step action",jobApplicationStepsObj);
        this.setApplicationStepsStatus(jobApplicationStepsObj);
        if (
          jobApplicationStepsObj &&
          jobApplicationStepsObj.workflowStepActions &&
          jobApplicationStepsObj.workflowStepActions == 0
        ) {
          // call the API with basic form data
        } else if (
          jobApplicationStepsObj &&
          jobApplicationStepsObj.workflowStepActions &&
          this.quickJobApplyAllowed(jobApplicationStepsObj.workflowStepActions)
        ) {
          let unOrderedJobApplicationSteps =
            jobApplicationStepsObj.workflowStepActions;
          if (unOrderedJobApplicationSteps) {
            unOrderedJobApplicationSteps.sort(
              (n1, n2) => n1['actionSequence'] - n2['actionSequence'],
            );
          }
          this.jobApplicationSteps = unOrderedJobApplicationSteps;
        } else {
          this.$wlToastr(
            'info',
            'Please signup to continue for the job application submission as this job involves multiple job application steps!',
            '',
          );
          this.$router.push({ name: 'Login' });
        }
      },
      (err) => {
        console.log(err);
      },
    );

    this.jobDetails().then((x) => {
      const job = this.jobDetail[0];

      this.skills = job.jobSkills; // jobSkills already is a list
      this.categories = []; // TBD
      this.industries = []; // TBD
      this.facilities = [...this.facilities, job.facility];
      this.jobResumeUploadRequired = job.resumeUploadRequired;
      this.updateCompanyInfo(job.companyCode);
      this.validateResume();
      const title =
        job.isRemote === 'true' || job.isRemote === 'yes'
          ? `${job.jobPostingName} - ${job.jobPostingId} | Jobs at ${
              job.companyName
            }`
          : `${job.jobPostingName} in ${job.facility.city}, ${
              job.facility.state
            } - ${job.jobPostingId} | Jobs at ${job.companyName}`;
      document.title = title;
      const metaTag = document.querySelector('meta[name="description"]');
      if (metaTag)
        metaTag.setAttribute(
          'content',
          `Apply to ${job.jobPostingName} (${this.jobTypeText(job)}) at ${
            job.companyName
          } -  ${job.facility.city}, ${job.facility.state}.`,
        );
      if (this.jobDetailsError) {
        const metaRobot: any = document.querySelector('meta[name="robots"]');
        metaRobot.setAttribute('content', 'noindex');
      }

      if (this.showSimilarJobs) {
        vxm.jobs.getSimilarJobs({
          jobId: this.$route.params.JobID,
          companyCode: job.companyCode,
        });
      }
      const hostMappedURL: string = vxm.configs.getGlobalConfigValue(
        'HOST_MAPPING',
      );
      if (hostMappedURL && window.location.host.includes('workllama.com')) {
        const head = document.querySelector('head');
        if (head) {
          const canonicalURL: string = hostMappedURL + this.$route.path;
          head.append('<link rel="canonical" href="' + canonicalURL + '" />');
        }
      }
    });
    if (
      vxm.jobs.jobId &&
      vxm.jobs.UserJob &&
      vxm.jobs.jobId === vxm.jobs.UserJob.jobPostingId
    ) {
      this.job_ = vxm.jobs.UserJob;
    }
  }
  setApplicationStepsStatus(jobApplicationStepsObj: any) {
    if (
      jobApplicationStepsObj &&
      jobApplicationStepsObj.workflowStepActions &&
      jobApplicationStepsObj.workflowStepActions.length > 0
    ) {
      jobApplicationStepsObj.workflowStepActions.forEach(
        (workflowStepAction) => {
          if (
            JobActionCodeConstants.RESUME_REQUIRED ===
            workflowStepAction['actionCode']
          ) {
            this.resumeUploadRequired = true;
          } else if (
            JobActionCodeConstants.QUESTIONNAIRE_REQUIRED ===
            workflowStepAction['actionCode']
          ) {
            this.questionnaireRequired = true;
          }
        },
      );
    } else {
      this.resumeUploadRequired = false;

      this.isResumeActionComplete = false;
      this.questionnaireRequired = false;
      this.questionnaireActionCompleted = false;
    }

    this.validateResume();
  }

  validateResume() {
    const resumeCode = this.jobResumeUploadRequired;
    if (
      !this.isResumeActionComplete &&
      (resumeCode === JobActionCodeConstants.RESUME_UPLOAD_OPTIONAL ||
        resumeCode === JobActionCodeConstants.RESUME_UPLOAD_NOT_REQUIRED)
    ) {
      this.isResumeActionComplete = true;
    }
  }

  get showAdminMessage(): string {
    if (
      this.job_.awaitingActionBy &&
      this.job_.awaitingActionBy === '01' &&
      this.job_.nextStepScheduleStartDTTM
    ) {
      var n = this.job_.nextStepScheduleStartDTTM.substring(
        this.job_.nextStepScheduleStartDTTM.indexOf('T'),
      );
      var res = n.replace(/-/g, ':');
      this.job_.nextStepScheduleStartDTTM = this.job_.nextStepScheduleStartDTTM.replace(
        n,
        res,
      );

      const startDTTM = new Date(this.job_.nextStepScheduleStartDTTM);

      const dateString = this.$moment(startDTTM).format('DD-MMM-YYYY');
      let timeStampString = this.$moment(startDTTM).format('hh:mm A');
      return `Your ${this.getJobPostingAssignmentText()} is scheduled on ${dateString} at ${timeStampString}`;
    } else {
      return this.getJobPostingAssignmentAlertStatusText();
    }
  }

  getJobPostingAssignmentAlertStatusText(): string {
    const translatedStatus = { 
      '20': this.$t('MyJobIntermediateStep_ApplicationScreened').toString(),
      '30': this.$t('MyJobIntermediateStep_SelectedForInterview').toString(),
      '35': this.$t('MyJobIntermediateStep_ApplicationReviewed').toString()
    };
    return translatedStatus[this.job_.jobPostingAssignmentStatus] || '';
  }

  getJobPostingAssignmentText() {
    if (
      this.job_.jobPostingAssignmentStatus ===
      this.JOBPOSTING_ASSIGNMENT_STATUS_SCREENING
    ) {
      return 'screening';
    } else if (
      this.job_.jobPostingAssignmentStatus ===
      this.JOBPOSTING_ASSIGNMENT_STATUS_INTERVIEW
    ) {
      return 'interview';
    } else if (
      this.job_.jobPostingAssignmentStatus ===
      this.JOBPOSTING_ASSIGNMENT_STATUS_REVIEW
    ) {
      return 'review';
    }
    return '';
  }

  updateCandidatePhone(event) {
    this.wlUser.phone =
      '+' + event.countryCallingCode + ' ' + event.nationalNumber;
    this.wlUser.phoneNumberValid = event.isValid;
  }

  get defaultCountry() {
    return vxm.utility.defaultCountry;
  }

  get supportedCountries() {
    return vxm.utility.supportedCountries;
  }

  nextStep() {
    vxm.jobs.setJobAdminMessage(this.job_.adminComment);
    this.$router.push({
      name: 'myjobstatusWorkflowStep',
      params: { JobID: this.job_.jobPostingId },
    });
  }

  // Get the company info from the server;
  updateCompanyInfo(companyCode) {
    const candidatePortalClientCommonInfo = new CandidatePortalClientCommonInfo();
    candidatePortalClientCommonInfo.radius = vxm.jobs.FilterRadius;
    candidatePortalClientCommonInfo.latitude = vxm.jobs.latitude;
    candidatePortalClientCommonInfo.longitude = vxm.jobs.longitude;
    candidatePortalClientCommonInfo.companyCode = companyCode;
    vxm.jobs
      .getCompanyInfo(candidatePortalClientCommonInfo)
      .then((companyInfo) => {
        this.CompanyInfo = companyInfo;
      });
  }

  getJobReferralProgramExists(job) {
    if (job.companyReferralIncentive != null) {
      return job.companyReferralIncentive.companyReferralIncentiveName !== 'NA'
        ? true
        : false;
    }
    return false;
  }
  
  get referralEnabled(){
    return vxm.configs.isReferralEnabled('REFERRAL_ENABLED');
  }

  toggleReferrals() {
    this.showDetail = !this.showDetail;
  }

  getToggleValue() {
    return this.showDetail;
  }

  renderDate(xDate: Date): string {
    if (vxm.jobs.getCompanyDateFormat) {
      return (
        'STARTING: ' +
        this.$moment(xDate).format(vxm.jobs.getCompanyDateFormat.toUpperCase())
      );
    }
    return 'STARTING: ' + this.$moment(xDate).format('DD-MMM-YYYY');
  }

  getCompanyLogoUrl(companyCode: string): string {
    return vxm.jobs.getCompanyLogoUrl(companyCode);
  }

  bookmarkJob(job: any) {
    let jobs = this.bookmarks.filter(
      (bookmark) => bookmark.objectId === job.jobPostingId,
    );
    if (jobs && jobs.length > 0) {
      for (let bookmark of this.bookmarks) {
        if (job.jobPostingId == bookmark.objectId) {
          if (job.bookmarkStatus && job.bookmarkStatus === 'A') {
            job.bookmarkStatus = 'D';
            bookmark.action = 'D';
          } else if (job.bookmarkStatus && job.bookmarkStatus === 'D') {
            job.bookmarkStatus = 'A';
            bookmark.action = 'A';
          }
        }
      }
    } else if (job.bookmarkStatus && job.bookmarkStatus === 'A') {
      job.bookmarkStatus = 'D';
      this.bookmarks.push({
        action: 'D',
        type: '01',
        objectId: job.jobPostingId,
      });
    } else if (job.bookmarkStatus && job.bookmarkStatus === 'D') {
      job.bookmarkStatus = 'A';
      this.bookmarks.push({
        action: 'A',
        type: '01',
        objectId: job.jobPostingId,
      });
    }

    let bookmarkIcon = this.$refs['bookmark_' + job.jobPostingId];
    if (job.bookmarkStatus && job.bookmarkStatus === 'A') {
      bookmarkIcon[0].classList = ['fa fa-bookmark add-color bookmark-icon'];
    } else if (job.bookmarkStatus && job.bookmarkStatus === 'D') {
      bookmarkIcon[0].classList = [
        'fa fa-bookmark-o remove-color bookmark-icon',
      ];
    }
    let req = {
      sessionToken: '13223',
      bookmarks: this.bookmarks,
    };
    if (this.bookmarks && this.bookmarks.length > 0) {
      vxm.jobs.bookmarkJob(req).then((resp) => {});
    }
  }

  destroyed() {
    localStorage.nextpage = '';
    vxm.jobs.setJobAdminMessage('');
  }

  getFirstCapitalletter(value: string): string {
    if (!value) return '';
    value = value.toString();
    return value
      .trim()
      .charAt(0)
      .toUpperCase();
  }

  formattingJobDescription(jobDescription: any) {
    if (
      !this.ShowFullDescription &&
      jobDescription &&
      jobDescription.length > this.MaxDescriptionLength
    ) {
      return `${jobDescription.substring(0, this.MaxDescriptionLength)}...`;
    }
    return jobDescription;
  }

  toggleSeeMore() {
    this.ShowFullDescription = !this.ShowFullDescription;
  }

  saveJob(job: Job) {
    const vm = this;
    this.localjobs.push(job);
    localStorage.setItem('localjobs', JSON.stringify(this.localjobs));
    vxm.utility.setLocaljobs(this.localjobs);
    vm.$wlToastr('success', vm.$t('MyJobListing_JobSavedSuccess'), vm.$t('savedJobs.text'));
  }

  deleteSavedJob(job: Job) {
    const vm = this;
    console.log('got job:' + job.jobPostingId);
    this.localjobs.forEach((item, index) => {
      if (item.jobPostingId == job.jobPostingId) {
        this.localjobs.splice(index, 1);
        console.log('deleting job');
      }
    });
    localStorage.setItem('localjobs', JSON.stringify(this.localjobs));
    vxm.utility.setLocaljobs(this.localjobs);
    vm.$wlToastr('success', vm.$t('MyJobListing_JobUnsavevSuccess'), vm.$t('savedJobs.text'));
  }

  isSavedJob(jobid) {
    const found = this.localjobs.find(
      (element) => element.jobPostingId == jobid,
    );
    console.log('job found:' + found);
    return found;
  }

  jobTypeText(job: Job): string {
    return this.$t(getJobTypeText(job)).toString();
  }

  closeCard() {
    if (vxm.users.isNewUser && !vxm.jobs.SkipGuidedSignUpOnApplication) {
      vxm.users.setNewUser(false);
      if (this.ShowGuidedSignup) {
        this.$router.push({ name: 'GuidedSignup' });
      } else {
        this.$router.push({ name: 'Findjobs' });
      }
    } else {
      this.$router.push({ name: 'Findjobs' });
    }
  }
  
  get UserTOSAgreementText() {
    const customTOStext = vxm.users.getUserLang == 'fr'  ? 
    vxm.configs.getGlobalConfigValue('USER_TOS_AGREEMENT_TEXT_FR') 
    :vxm.configs.getGlobalConfigValue('USER_TOS_AGREEMENT_TEXT');
    if (customTOStext) return customTOStext
      .replace(/{companyName}/g, vxm.utility.companyName)
      .replace(/{termsOfServiceURL}/g, this.termsOfServiceURL)
      .replace(/{privacyPolicyURL}/g, this.privacyPolicyURL);

    return this.$t('signup.terms.services', {
      termsOfServiceURL: this.termsOfServiceURL,
      privacyPolicyURL: this.privacyPolicyURL,
      companyName: vxm.utility.companyName
    })
  }
}
